import type { ReactNode } from "react";

import { MediaLibraryContextProvider } from "src/pages/Settings/MediaLibrary/context";
import { TokenSuggestionsProvider } from "src/components/Puck/config/fields/extensions/typingSuggestions/TokenSuggestionsProvider";
import { PuckActionPlanProvider } from "src/components/Puck/config/contexts/PuckActionPlanContext";
import { StrategyProvider } from "src/context/Strategy/provider";
import { PuckCompanyScoreProvider } from "src/components/Puck/config/contexts/PuckCompanyScoreContext";
import { CompanyMetadataProvider } from "src/context/Company/Metadata/provider";

export const PuckEditorProviders = (props: { companyId: number | undefined; children: ReactNode }) => {
    const { companyId, children } = props;

    return companyId !== undefined ?
            <CompanyMetadataProvider companyId={companyId}>
                <PuckCompanyScoreProvider>
                    <PuckActionPlanProvider>
                        <StrategyProvider>
                            <TokenSuggestionsProvider>
                                <MediaLibraryContextProvider>{children}</MediaLibraryContextProvider>
                            </TokenSuggestionsProvider>
                        </StrategyProvider>
                    </PuckActionPlanProvider>
                </PuckCompanyScoreProvider>
            </CompanyMetadataProvider>
        :   <PuckCompanyScoreProvider>
                <PuckActionPlanProvider>
                    <StrategyProvider>
                        <TokenSuggestionsProvider>
                            <MediaLibraryContextProvider>{children}</MediaLibraryContextProvider>
                        </TokenSuggestionsProvider>
                    </StrategyProvider>
                </PuckActionPlanProvider>
            </PuckCompanyScoreProvider>;
};
